import * as Yup from 'yup';
import { AdvertiseStatus } from '../enum';

const advertiseId = Yup.string()
  .trim()
  .when('isBulkAction', {
    is: true,
    then: Yup.string().optional(),
    otherwise: Yup.string().required('Advertise is required'),
  })
  .label('Advertise');

// Add validation for advertiseIds in bulk operations
const advertiseIds = Yup.array()
  .when('isBulkAction', {
    is: true,
    then: Yup.array()
      .min(1, 'At least one advertisement must be selected')
      .required('Selected advertisements are required'),
    otherwise: Yup.array().optional(),
  })
  .label('Selected Advertisements');

// const startDate = Yup.date()
//   .min(new Date(), 'Start Date cannot be in the past')
//   .nullable()
//   .label('Start Date');
// const startDate = Yup.date()
//   .transform(function (value, originalValue) {
//     return originalValue ? new Date(originalValue.setHours(0, 0, 0, 0)) : originalValue;
//   })
//   .min(
//     new Date(new Date().setHours(0, 0, 0, 0)),
//     'Start Date cannot be in the past'
//   )
//   .nullable()
//   .label('Start Date');

const rejectionReason = Yup.string()
  .trim()
  .when('status', {
    is: (val: string) => val === AdvertiseStatus.rejected || val === AdvertiseStatus.suspended,
    then: Yup.string().required('Reason is required for rejection or suspension'),
    otherwise: Yup.string().optional(),
  })
  .label('Rejection Reason');

const changeAdvertiseStatusSchema = Yup.object().shape({
  advertiseId,
  advertiseIds,
  status: Yup.string()
    .trim()
    .oneOf([
      AdvertiseStatus.approved, 
      AdvertiseStatus.rejected, 
      AdvertiseStatus.published, 
      AdvertiseStatus.expired,
      AdvertiseStatus.suspended
    ], 'Select a valid status option')
    .optional()
    .label('Status'),
  endDate: Yup.date()
    .min(new Date(), 'Expiry date must be in the future')
    .nullable()
    .optional()
    .label('End Date'),
  rejectionReason,
  isBulkAction: Yup.boolean().optional(),
}).test('status-or-endDate', 'Either status or endDate must be provided', function(value) {
  // At least one of status or endDate must be provided
  return !!(value.status || value.endDate);
});

export default changeAdvertiseStatusSchema;
